import { render } from "./Recruitment.vue?vue&type=template&id=483a3e94&ts=true"
import script from "./Recruitment.vue?vue&type=script&lang=ts"
export * from "./Recruitment.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__